// @flow

import React from 'react';
import Tabs from 'react-aaui/lib/tabs';
import L10nMessage from 'react-aaui/lib/shared/L10nMessage';
import Result from '../Result/Result';
import LeaderBoard from '../LeaderBoard/LeaderBoard';

type Props = {
  className?: string,
  resultType: string,
  onChangeResultType: Function,
}

const Dashboard = ({
  className,
  resultType,
  onChangeResultType,
}: Props) => (
  <div className={className}>
    <Tabs className="event-result-tab" selected={resultType} onChange={onChangeResultType}>
      <Tabs.Header>
        <Tabs.Title name="RESULT">
          <span className="event-result-tab__tag"><L10nMessage id="page.event.result" /></span>
        </Tabs.Title>
        <Tabs.Title name="LEADER_BOARD">
          <span className="event-result-tab__tag"><L10nMessage id="page.event.liveUpdates" /></span>
        </Tabs.Title>
      </Tabs.Header>
      <Tabs.Container name="RESULT">
        <Result />
      </Tabs.Container>
      <Tabs.Container name="LEADER_BOARD">
        {resultType === 'LEADER_BOARD' && <LeaderBoard />}
      </Tabs.Container>
    </Tabs>
  </div>
);

Dashboard.defaultProps = {
  className: '',
};

export default Dashboard;
